import {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import EditBulkCard from './add-bulk/EditBulkCard'
import '../../modules/reports/payment-video.css'
import './add-special/add-discount-bulk.css'
import {TutorialVideoLink} from '../../tenant/TutorialVideoLink'
import ShopScopeBanner from '../../components/ShopScopeBanner'

// Reuses the Add Discount - Bulk visual system (.adb-*); only the card body
// (EditBulkCard) keeps its own bulk-update API implementation.
const UpdateBulk = () => {
  const {formatMessage} = useIntl()
  const [showVideoHighlight, setShowVideoHighlight] = useState(false)

  useEffect(() => {
    const hasSeenVideo = document.cookie
      .split(';')
      .some((item) => item.trim().startsWith('update_bulk_video='))

    setShowVideoHighlight(!hasSeenVideo)
  }, [])

  return (
    <div className='adb-root'>
      <ShopScopeBanner />
      <div className='adb-header'>
        <div>
          <h1 className='adb-title'>{formatMessage({id: 'edit_prod_bulk'})}</h1>
          {/* Multi-supplier: bulk update writes to YOUR offer (price /
              quantity), not the shared catalog content. */}
          <div className='adb-note' role='note'>
            <i className='fas fa-circle-info' aria-hidden='true' />
            <span>{formatMessage({id: 'bulk_update_offer_note'})}</span>
          </div>
        </div>

        <TutorialVideoLink
          section='products_update_bulk'
          fallback='https://www.youtube.com/watch?v=MoB7bP3j8gY'
          target='_blank'
          rel='noopener noreferrer'
          className={`adb-tutorial-btn ${showVideoHighlight ? 'video-highlight' : ''}`}
          onClick={() => {
            document.cookie = 'update_bulk_video=seen'
            setShowVideoHighlight(false)
          }}
        >
          <i className='fas fa-circle-play' aria-hidden='true' />
          {formatMessage({id: 'watch_tutorial'})}
        </TutorialVideoLink>
      </div>

      <EditBulkCard />
    </div>
  )
}

export default UpdateBulk
